/// <amd-module name="Repos/Views/PullRequest/Markdown/DiscussionProps" />
import { IPullRequestMarkdownToolbarContext } from "Repos/Common/Contracts/Markdown";
import { previewOptions } from "Repos/Discussion/Utils/Markdown";
import { tryAttachingPastedImage } from "Repos/PullRequest/Attachments/Attachment";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { shortcutCommands } from "VSS/Features/MarkdownEditor/Commands/Shortcut";
import { toolbarCommands } from "VSS/Features/MarkdownEditor/Commands/Toolbar";
import { IMarkdownPreviewProps, IMarkdownTextFieldProps, IMarkdownToolbarProps } from "VSS/Features/MarkdownEditor/Components";
import { IVssPageContext } from "VSS/Platform/Context";
import { IGitPullRequestCommentThreadModel } from "../Discussion/PullRequestDiscussionThreadService";
import { getCheckboxMarkdownTransformer } from "./Checkbox";
import { getMarkdownCommands as getCodeSuggestionCommands, getMarkdownTransformers as getCodeSuggestionTransformers } from "./CodeSuggestion";

export function getMarkdownTextFieldProps(
    pageContext: IVssPageContext,
    pullRequestMarkdownContext: IPullRequestMarkdownToolbarContext
): IMarkdownTextFieldProps {
    return {
        messageText: Resources.AttachmentSupportMessage,
        onPaste: (e, textSource) => tryAttachingPastedImage(e, pageContext, pullRequestMarkdownContext, textSource),
        shortcutCommands
    };
}

export function getMarkdownToolbarProps(
    pageContext: IVssPageContext,
    pullRequestMarkdownContext: IPullRequestMarkdownToolbarContext,
    threadModel?: IGitPullRequestCommentThreadModel
): IMarkdownToolbarProps {
    return {
        commands: [...toolbarCommands, ...getCodeSuggestionCommands(pageContext, threadModel)],
        contributionContext: pullRequestMarkdownContext,
        contributionId: "ms.vss-code-web.pr-details-markdown-commands"
    } as IMarkdownToolbarProps;
}

export function getMarkdownPreviewProps(
    pageContext: IVssPageContext,
    threadModel?: IGitPullRequestCommentThreadModel,
    onMarkdownChanged?: (newContent: string) => void,
    canChangeMarkup?: () => boolean
): IMarkdownPreviewProps {
    const rendererOptions = { ...previewOptions };

    if (!rendererOptions.transformers) {
        rendererOptions.transformers = [];
    }

    const suggestionTransformers = getCodeSuggestionTransformers(pageContext, threadModel);
    for (const transformer of suggestionTransformers) {
        rendererOptions.transformers.push(transformer);
    }

    if (onMarkdownChanged) {
        rendererOptions.transformers.push(getCheckboxMarkdownTransformer(onMarkdownChanged, canChangeMarkup));
    }

    return { options: rendererOptions };
}
